import React from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import CheckboxButton from 'components/buttons/CheckboxButton';
import { options } from '../content';

const SecondStep = ({ setActiveStep, dispatchWidget, widgetState }) => {
  const handleCheckboxChange = data => {
    const targetName = data.name;

    dispatchWidget({
      type: 'UPDATED_WIDGET',
      payload: { [targetName]: data.value }
    });
  };

  const handleBack = () => setActiveStep(prev => prev - 1);

  const handleNextStep = () => {
    setActiveStep(prev => prev + 1);
  };

  return (
    <>
      <Grid container direction="row" justify="flex-start" alignItems="stretch" spacing={1}>
        <Grid
          item
          container
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
          xs={12}
          md={8}
        >
          <Grid item xs={12}>
            <h3 style={{ marginBottom: '10px', marginTop: '0', opacity: '0.7' }}>Settings:</h3>
          </Grid>
          {options &&
            options.map(option => (
              <Grid item xs={12} md={12} key={option.title}>
                <CheckboxButton
                  title={option.title}
                  checked={widgetState[option.name]}
                  name={option.name}
                  onChange={handleCheckboxChange}
                  hasTransparentBg
                />
              </Grid>
            ))}
        </Grid>
      </Grid>
      <Divider style={{ width: '100%', marginTop: '20px' }} />
      <Grid container direction="row" justify="space-between" alignItems="center" spacing={2}>
        <Grid item xs={4} md={4}>
          <Box display="flex" my={2} justifyContent="flex-start" mr="auto">
            <Button
              variant="outlined"
              style={{ marginRight: '8px' }}
              color="primary"
              onClick={handleBack}
            >
              Back
            </Button>
          </Box>
        </Grid>

        <Grid item xs={4} md={4}>
          <Box display="flex" my={2} justifyContent="flex-end" ml="auto">
            <Button variant="contained" color="primary" onClick={handleNextStep}>
              Next
            </Button>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
SecondStep.propTypes = {
  baseWidgetWidth: PropTypes.number.isRequired,
  dispatchWidget: PropTypes.func.isRequired,
  setActiveStep: PropTypes.func.isRequired,
  setBaseWidgetWidth: PropTypes.func.isRequired,
  widgetState: PropTypes.shape({}).isRequired
};

export default SecondStep;
